// @flow
import React from 'react';

/**
 * Renders the preloader
 */
const Loader = ({ children }) => {
    return (
        <div className="custom-loader  position-relative  p-3">
            <div className="preloader">
                <div className="status" id="status">
                    <div className="bouncing-loader">
                        <div className="bouncing-loader__container">
                            <div className="bouncing-loader__dot  bouncing-loader__dot--1"></div>
                            <div className="bouncing-loader__dot  bouncing-loader__dot--2"></div>
                            <div className="bouncing-loader__dot  bouncing-loader__dot--3"></div>
                        </div>
                    </div>
                    {children ? (
                        children.map( (child, index) => {
                            return (
                                <div key="index">
                                    {child}
                                </div>
                            )
                        })
                    ) : (
                        <></>
                    )}
                </div>
            </div>

        </div>
    );
};

export default Loader;
